import React from "react";
import { Button } from "@mui/material";
import { withTheme } from "@emotion/react";

function TextButton(props) {
  const theme = props.theme;

  return (
    <>
      <Button
        sx={{
          width: props.width,
          height: props.height,
          ...theme.button.text,
          ...theme.typography.button,
          color: props.color ?? theme.button.text.color
        }}
      >
        {props.text}
      </Button>
    </>
  );
}

export default withTheme(TextButton);
